import axios, { AxiosResponse } from 'axios'

import { SaleRequest, SaleResponse } from '../model/checkout.model'

export default class CheckoutService {
  constructor(private apiGateway: string) {}

  createOrder(body: SaleRequest): Promise<AxiosResponse<SaleResponse>> {
    return axios
      .post(`${this.apiGateway}/sales/v1/masmovil/sales`, body, {
        headers: {
          'Content-Type': 'application/json',
        },
      })
      .then((response) => response)
  }
}
